import React from 'react'
import UserRecordsFilter from './UserRecordsFilter';
import ProfileRecordsFilter from './ProfileRecordsFilter';
import SaleRecordsFilter from './SaleRecordsFilter';
import Submission from './Submission';

function FilterForm({ onSubmit, onClear, resultsCount }) {
    return (
        <div className='pt-[80px] pb-[110px]'>
            <div className='mt-5'>
                <UserRecordsFilter />
            </div>
            <div className='mt-5'>
                <ProfileRecordsFilter />
            </div>
            <div className='mt-5'>
                <SaleRecordsFilter />
            </div>
            <div>
                <Submission onSubmit={onSubmit} onClear={onClear} resultsCount={resultsCount} />
            </div>
        </div>
    )
}

export default FilterForm